module.exports = __webpack_public_path__ + "static/media/scan.20794ce6.png";